import { AttachmentTiles } from "@/components/chat/AttachmentTiles";
import { SaveCreativeButton } from "@/components/creative-materials/SaveCreativeButton";
import { ThreadAssetView } from "@/lib/api";

interface ThreadAssetTilesProps {
  assets: Array<ThreadAssetView>;
  onRemoveAsset?: (assetToken: string) => void;
}

function isPreviewableThreadAsset(asset: ThreadAssetView): boolean {
  const kind = asset.ref.kind;
  const src = asset.ref.publicUrl;

  return Boolean(src) && (kind === "image" || kind === "video");
}

/**
 * Image/video preview grid for the artifact-pane Assets section.
 * Documents and PDFs are skipped on this surface. One AttachmentTiles so
 * testids stay unique and the lightbox pages across assets.
 */
export function ThreadAssetTiles(props: ThreadAssetTilesProps) {
  const { assets, onRemoveAsset } = props;

  const previewable = assets.filter(isPreviewableThreadAsset);

  if (previewable.length === 0) {
    return null;
  }

  return (
    <div className="min-w-0" data-testid="thread-asset-tiles">
      <AttachmentTiles
        items={previewable.map((asset) => ({
          src: asset.ref.publicUrl ?? "",
          mimeType: asset.ref.mimeType,
          label: asset.ref.label,
        }))}
        testIdPrefix="thread-asset"
        align="start"
        onRemoveAtIndex={
          onRemoveAsset
            ? (index) => {
                const asset = previewable[index];
                if (asset) {
                  onRemoveAsset(asset.token);
                }
              }
            : undefined
        }
      />
      {previewable.some((asset) => asset.canSaveToCreatives === true) && (
        <div className="flex flex-wrap gap-2 pt-2">
          {previewable
            .filter((asset) => asset.canSaveToCreatives === true)
            .map((asset) => (
              <SaveCreativeButton
                key={asset.token}
                assetToken={asset.token}
                title={asset.ref.label ?? ""}
              />
            ))}
        </div>
      )}
    </div>
  );
}
